import axios from 'axios';
import store from '../store';
import verifyAuth from '../services/utilities' 

class MetaTraderServerDetailsRepository {
    constructor(){
        this.basePath = store.state.backend;
    }

    getMetaTraderServersByPartner(partnerId){
        let response = axios.get(`${this.basePath}/meta-trader-server-details/by-partner/${partnerId}`);
        response = verifyAuth(response) 
        return response;
    }
}

export default new MetaTraderServerDetailsRepository();
